import { env } from "process";

/* PREPROD */
const environmentPreprod = {
  production: true,
  apiRpps: {
    url: 'https://victor-cors.herokuapp.com/https://ws-rpps.vivacy.com/rpps/check',
    username: 'smD5thohv^GAUQ7R&%v@45egr',
    password: 'a#gntKhiV6!5ibBW*$*msfhiu',
    headers: {
      origin: 'X-Requested-With',
    },
  },
  firebase: {
    apiKey: 'AIzaSyC2Qc5Z6aRmIu3IIlrTk7mNyCrlJ2-3IMc',
    authDomain: 'vivacy-backoffice-dev.web.app',
    databaseURL:
      'https://vivacy-dev-67ec1-default-rtdb.europe-west1.firebasedatabase.app',
    projectId: 'vivacy-dev-67ec1',
    storageBucket: 'vivacy-dev-67ec1.appspot.com',
    messagingSenderId: '1016180909710',
    appId: '1:1016180909710:web:84bfe60a78870912940bdf',
  },
  recaptcha: {
    siteKey: '6Lf76uUcAAAAABRE-YykfFwBuRG1f_4NuVYiJLAD',
  },
};

/* PROD */
const environmentProd = {
  production: true,
  apiRpps: {
    url: 'https://victor-cors.herokuapp.com/https://ws-rpps.vivacy.com/rpps/check',
    username: 'smD5thohv^GAUQ7R&%v@45egr',
    password: 'a#gntKhiV6!5ibBW*$*msfhiu',
    headers: {
      origin: 'X-Requested-With',
    },
  },
  firebase: {
    apiKey: 'AIzaSyAP2A0jD7WtA6BaxDC_9Sg9ZGStr9xsZWc',
    authDomain: 'vivacy-96b29.firebaseapp.com',
    databaseURL:
      'https://vivacy-96b29-default-rtdb.europe-west1.firebasedatabase.app',
    projectId: 'vivacy-96b29',
    storageBucket: 'vivacy-96b29.appspot.com',
    messagingSenderId: '334428967318',
    appId: '1:334428967318:web:e7a8ece7e5f8dcd88d0db7',
    measurementId: 'G-D4CNLC5QFH',
  },
  recaptcha: {
    siteKey: '6Lf76uUcAAAAABRE-YykfFwBuRG1f_4NuVYiJLAD',
  },
};

export const environment = environmentProd;
